// Production URLs embed params in the pathname, e.g.:
// https://responde.sondeociudadano.mx/cookie=6a8f1d4b28da2
// https://responde.sondeociudadano.mx/cookie=6a8f1d4b28da2&test=1&chart=true

export function getUrlParams(location = window.location) {
    const params = new URLSearchParams();
    const pathPart = location.pathname.replace(/^\/?\??/, "");
    const searchPart = location.search.replace(/^\?/, "");

    if (pathPart) {
        new URLSearchParams(pathPart).forEach((value, key) => params.set(key, value));
    }
    if (searchPart) {
        new URLSearchParams(searchPart).forEach((value, key) => params.set(key, value));
    }
    return params;
}

export function getUrlParam(name, location = window.location) {
    return getUrlParams(location).get(name);
}

export function isUrlFlag(name, location = window.location) {
    const value = getUrlParam(name, location);
    if (!value) return false;
    const normalized = value.replace("/", "").toLowerCase();
    return normalized === "true" || normalized === "1";
}

export function getPollId(location = window.location) {
    const cookie = getUrlParam("cookie", location);
    return cookie ? cookie.replace("/", "") : null;
}
